import React from 'react'
import { useTranslation } from 'react-i18next'

import CircularProgress from '@mui/material/CircularProgress'

import { loadMachines, machinesLoaded, machinesLoadError } from '../../store/actions'
import { useContextHook } from '../../store/context'
import { Machine } from '../../types/machine'
import { get } from '../../utils/service'
import Alert from '../alert/alert'

const MachineLoader = (): JSX.Element => {
  const { t } = useTranslation()
  const { state, dispatch } = useContextHook()

  const [loadMachinesUrl, setLoadMachinesUrl] = React.useState<string>('')

  // when loadMachinesUrl, load machines
  React.useEffect(() => {
    if (loadMachinesUrl) {
      dispatch(loadMachines())
      get<Array<Machine>>(loadMachinesUrl)
        .then((response) => {
          dispatch(machinesLoaded(response.data))
        })
        .catch(() => dispatch(machinesLoadError()))
    }
  }, [loadMachinesUrl, dispatch])

  React.useEffect(() => {
    if (state.machines.length === 0 && state.currentCustomer?.id) {
      setLoadMachinesUrl(`machines/?owner=${state.currentCustomer.id}&page_size=all`)
    }
  }, [state.machines, state.currentCustomer?.id])

  return (
    <>
      {state.loadMachinesError && <Alert severity="error">{t('mainview.machinesloaderror')}</Alert>}
      {state.isLoadingMachines && <CircularProgress />}
    </>
  )
}

export default MachineLoader
